import { Model } from 'pinia-orm';
// eslint-disable-next-line import/no-cycle -- pinia-orm bidirectional relation: User.telegramUser ↔ TelegramUser.user requires both classes to reference each other
import User from './User';

export default class TelegramUser extends Model {
  static entity = 'telegramUsers';

  static fields() {
    return {
      id: this.uid(),
      firstName: this.attr(''),
      lastName: this.attr(null),
      username: this.attr(''),
      languageCode: this.attr(null),
      isPremium: this.attr(false),
      photoUrl: this.attr(null),
      createdAt: this.attr(''),
      updatedAt: this.attr(''),
      userId: this.attr(null),

      user: this.belongsTo(User, 'userId'),
    };
  }
}
